module.exports = __webpack_public_path__ + "media/app/components/TagsNavBar/farmToBusiness.b5439eb5.svg";